module.exports = __webpack_public_path__ + "static/locations-with-callouts-2dfa0c51903bbc8b91b8d8f20dd7213f.png";